import { Phone, Mail, MapPin, MessageCircle, Instagram } from "lucide-react";
import { Seo } from "@/components/Seo";
import { SITE, waLink } from "@/constants/site";
import { track } from "@/lib/api";

export default function Contact() {
  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16" data-testid="contact-page">
      <Seo title="Contact" description="Get in touch with ERRAH for surface protection in Noida / Delhi NCR." />
      <p className="errah-label gold-text mb-4">Contact</p>
      <h1 className="font-display text-4xl lg:text-6xl font-light tracking-tighter">Let's protect your surfaces.</h1>

      <div className="mt-12 grid md:grid-cols-2 gap-4 max-w-4xl">
        <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { location: "contact" })}
          data-testid="contact-whatsapp" className="hair-border bg-white/[0.02] p-8 hover:bg-white/[0.04] transition-colors flex items-center gap-4">
          <MessageCircle className="text-[#25D366]" size={26} />
          <div><p className="errah-label">WhatsApp</p><p className="font-display text-lg">Chat with ERRAH</p></div>
        </a>
        <a href={`tel:${SITE.phone}`} onClick={() => track("phone_click", {})} data-testid="contact-phone"
          className="hair-border bg-white/[0.02] p-8 hover:bg-white/[0.04] transition-colors flex items-center gap-4">
          <Phone className="text-[#C9A45C]" size={26} />
          <div><p className="errah-label">Call</p><p className="font-display text-lg">{SITE.phone}</p></div>
        </a>
        <div className="hair-border bg-white/[0.02] p-8 flex items-center gap-4">
          <Mail className="text-[#C9A45C]" size={26} />
          <div>
            <p className="errah-label">Email</p>
            <a href={`mailto:${SITE.email}`} data-testid="contact-email" className="block font-display text-lg hover:text-[#C9A45C] transition-colors">{SITE.email}</a>
            <a href={`mailto:${SITE.supportEmail}`} data-testid="contact-support-email" className="block font-display text-lg hover:text-[#C9A45C] transition-colors">{SITE.supportEmail}</a>
          </div>
        </div>
        <div className="hair-border bg-white/[0.02] p-8 flex items-center gap-4">
          <MapPin className="text-[#C9A45C]" size={26} />
          <div><p className="errah-label">Serving</p><p className="font-display text-lg">{SITE.city}</p></div>
        </div>
        <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram"
          className="hair-border bg-white/[0.02] p-8 hover:bg-white/[0.04] transition-colors flex items-center gap-4">
          <Instagram className="text-[#C9A45C]" size={26} />
          <div><p className="errah-label">Instagram</p><p className="font-display text-lg">@the_errah</p></div>
        </a>
      </div>
    </div>
  );
}
